import React from 'react';
import { Link, Tag } from '@chakra-ui/react';
import { BiImage } from 'react-icons/bi';
import { errorToast, FILE_SIZE_LIMIT , REALTOR_TYPE , LENDER_TYPE } from 'constants/index';
import { getAddressString } from 'utils/address';

import 'assets/css/file.scss';
import 'assets/css/Table.scss';
export default function FileInput({
    setfile,
    title = '',
    file,
    required = false ,
    label = 'Document',
    isPreview = false,
    handleRemove,
    isLoading,
    handleView,
    data = [],
    errors = [],
    selectedType = REALTOR_TYPE
}) {
    // File
    const [, setimageError] = React.useState(false);
    // upload file section  is here
    const handleUpload = (e) => {
        const selectedFile = e.target.files?.[0] || null;
        const size = (selectedFile.size / 1024 / 1024).toFixed(2);

        if (size > FILE_SIZE_LIMIT) {
            errorToast(`File size should be less than ${FILE_SIZE_LIMIT} MB.`);
            return;
        }
        setimageError(false);
        setfile(selectedFile);
    };

    const handleBrowse = ()=>{
        let input = document.getElementById('file-select-input');
        input.click();
    };

    if (isLoading) {
        return (
            <React.Fragment>
                <p>Loading the content of the uploaded file  please wait....</p>
            </React.Fragment>
        );
    } else if (file && (data?.length > 0 || errors?.length > 0)) {
        return (
            <React.Fragment>
                {
                    errors?.length > 0 &&
                    <>

                        <div className="list-table-container">
                            <table>
                                <thead>
                                    <tr>
                                        <th className='danger-text'>
                                            {errors?.length} Errors Detected
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        errors.map((error, index)=>(
                                            <tr key={index}>
                                                <td className='danger-text'>
                                                    {error}
                                                </td>
                                            </tr>

                                        ))
                                    }
                                </tbody>
                            </table>

                        </div>
                        <br />

                        <p>Invitation will be sent to only valid records. Invalid records that are corrected will need to be submitted again using a new file. This will prevent any duplicate invitation.</p>
                    </>
                }
                {data?.length > 0 &&

                <div className="list-table-container">

                    <table>
                        <thead>
                            <tr>
                                <th colSpan={8} className='bold-text success-text'>
                                    {data?.length} Successfully Selected
                                </th>
                            </tr>

                            <tr>
                                <th>
                         First Name
                                </th>
                                <th>
                            Last Name
                                </th>
                                <th>
                            Email
                                </th>
                                <th>
                            Address
                                </th>
                                <th>
                                    State Licenses
                                </th>
                                <th>
                            Company Name
                                </th>
                                <th>
                            Company Email
                                </th>
                                {
                                    selectedType === LENDER_TYPE &&
                                    <>
                                        <th>
                                 Company Phone
                                        </th>
                                        <th>
                            Company Website
                                        </th>
                                        <th>
                            Company Fax
                                        </th>
                                    </>
                                }

                                <th>
                            Company Address
                                </th>
                            </tr>

                        </thead>
                        <tbody>

                            {data.map((row, index)=>(
                                <tr key={index}>
                                    <td>
                                        {row.FirstName}
                                    </td>
                                    <td>
                                        {row.LastName}
                                    </td>
                                    <td>
                                        {row.Email}
                                    </td>
                                    <td>
                                        {getAddressString(row.Address)}

                                    </td>
                                    <td>
                                        {
                                            row && row?.Statelicenses?.map((state,index)=>(
                                                <Tag colorScheme='teal' key={index} m={2}>{state.label}</Tag>
                                            ))
                                        }
                                    </td>
                                    <td>
                                        {row.companyInfo.companyName}
                                    </td>
                                    <td>
                                        {row.companyInfo.companyEmail}
                                    </td>

                                    {
                                        selectedType === LENDER_TYPE &&
                                    <>
                                        <td>
                                            {row?.companyInfo?.companyPhone}
                                        </td>
                                        <td>
                                            {row?.companyInfo?.website}
                                        </td>
                                        <td>
                                            {row?.companyInfo?.fax}
                                        </td>
                                    </>
                                    }

                                    <td>
                                        {getAddressString(row.companyInfo.Address)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                }
            </React.Fragment>
        );
    } else {
        return (
            <div>

                <div className='content-box dropzone-area' >
                    <input accept='.xlsx, .csv' style={{ visibility: 'hidden' }} type='file' max={1} id='file-select-input' onChange={handleUpload} />
                    <div className= { file ? 'file-select-row-wrapper space-between-box select-success' : 'file-select-row-wrapper space-between-box'} >
                        <div className='icon-box'>
                            <BiImage className='icon'/>
                        </div>
                        <div className='text-box'>
                            <p >{title}{ required && <span className='required'> *</span>}</p>
                            <p>XLSX, CSV not larger than {FILE_SIZE_LIMIT}MB in size</p>
                        </div>
                        {
                            !isPreview &&
                <button onClick={handleBrowse} disabled={isLoading} type='button' className='browse-button'> {isLoading ? 'Uploading...' : 'Browse'}</button>
                        }
                        {
                            file && <button type='button' disabled={isLoading } className='remove-button' onClick={handleRemove}>Remove</button>
                        }

                    </div>
                    <div>
                        <Link color={'blue'} href=
                            {
                                selectedType === LENDER_TYPE
                                    ? 'https://idfi-assets.s3.us-east-2.amazonaws.com/assets/sample_lender_invite.xlsx'
                                    : 'https://idfi-assets.s3.us-east-2.amazonaws.com/assets/sample_realtor_invite.xlsx'} download={true}>

                    Download sample xlsx file for format.
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}
